// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"styles_scrollbars__b4avH","grid":"styles_grid__W74nN","subTitle":"styles_subTitle__MXEC5","slideInSearchBar":"styles_slideInSearchBar__bSRw0"};